import { EditorState } from '../types';

export const setSkimmingEnabled = (
  state: EditorState,
  enabled: boolean,
): EditorState => {
  if (state.isSkimmingEnabled === enabled) {
    return state;
  }
  return {
    ...state,
    isSkimmingEnabled: enabled,
  };
};

export const toggleSkimming = (state: EditorState): EditorState => {
  return setSkimmingEnabled(state, !state.isSkimmingEnabled);
};
